import { fromEvent, map } from "rxjs";
import { emailAddress as emailAddressPattern } from "constants/regexExpressions";
import validateEmailAddress from "../apis/validateEmailDomain";

export default class EmailInput {
  constructor() {
    this.valueInput = '';
    this.errorMessageId = 'nhs_ErrorForEmail';
    this.id = 'MailAddress';
    this.errorCssClass = 'error';
    this.errorMessage = `<span id="${this.errorMessageId}" class="form__error" hidden>
                           Please enter a valid email address
                         </span>`;
    this.label = `<label for="${this.id}" class="nhs-u-text--visually-hidden">Email Address</label>`;
  }

  set value(newValue){
    this.valueInput = newValue || '';
  }

  get value(){
    return this.valueInput;
  }

  getHtml() {
    return `${this.label}<input data-qa="email-input" data-segment-identity-data="email" id="${this.id}" class="form__input" 
                  placeholder="*Email Address" maxlength="50" name="email" autocomplete="email" 
                  type="email" required value="${this.value}" data-form-email-input></input>${this.errorMessage}`;
  }

  getNode() {
    return document.getElementById(this.id);
  }

  /**
   * getOnChangeEvent: On input change map its value to the storage property.
   */
  getOnChangeEvent() {
    return fromEvent(this.getNode(), 'change').pipe(
      map((event) => ({email: event.target.value}))
    );
  }

  setInvalidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.setAttribute('aria-invalid', true);
    node.classList.add(this.errorCssClass);
    errorMessage.removeAttribute('hidden');
  }

  setValidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.removeAttribute('aria-invalid');
    node.classList.remove(this.errorCssClass);
    errorMessage.setAttribute('hidden', true);
  }

  /**
   * Validates the email input value against a predefined pattern.
   * 
   * This function ensures that the email input value is cleaned by trimming
   * leading and trailing spaces and replacing multiple spaces with a single space.
   * The cleaned value is then updated in the UI and validated against the 
   * `matchingPattern` regular expression.
   * 
   * @returns {boolean} Returns `true` if the cleaned email value matches the pattern, otherwise `false`.
   */
  isValidEmailPattern() {
    const node = this.getNode();

    /* NHS20-1684: we verify that the value taken from the input it's clean,
    in case of spaces before and after the text, also is updated in the UI. */
    const cleanedValue = node.value.trim().replace(/\s+/g, ' ');
    node.value = cleanedValue;
    return emailAddressPattern.test(node.value);
  }

  validate() {
    const node = this.getNode();
    let isValid = this.isValidEmailPattern();
    
    return new Promise((resolve) => {
      if (isValid) {
        validateEmailAddress(node.value)
          .then((result) => {
            isValid = result;
  
            if (isValid) {
              this.setValidState(node);
            } else {
              this.setInvalidState(node);
            }
  
            resolve(isValid);
          })
          .catch(() => {
            this.setInvalidState(node);
            resolve(false);
          });
      } else {
        this.setInvalidState(node);
        resolve(false);
      }
    });
  }
  
}
